export default __webpack_public_path__ + "static/media/Sports & Athleisure.98140f5c.jpg";